import OrgsService from '../../../services/orgs';
import { FinancialAccountNode } from '../../../services/orgs/interfaces';
import { getKycById } from '../../../services/vault/kyc';

export const getPrimaryKycData = async (
  financialAccountId: string,
  provider: VaultProvider,
): Promise<{ kyc?: Kyc; stripePersonId?: string; userId?: string }> => {
  const financialAccountUsers =
    await OrgsService.getFinancialAcctUsers(financialAccountId);

  const financialAccountUser = financialAccountUsers.find(
    (fau) => fau.processor === provider.toUpperCase() && fau.isRepresentative,
  );

  let kyc: Kyc | undefined = undefined;
  if (financialAccountUser?.kycId !== undefined) {
    kyc = await getKycById(financialAccountUser.kycId);
  }

  return {
    kyc,
    stripePersonId: financialAccountUser?.personId,
    userId: financialAccountUser?.userId,
  };
};

export const getKycIsInherited = async (
  kycId: string,
  financialAccountRoots: FinancialAccountNode[],
): Promise<boolean> => {
  let kycIsInherited = false;
  for (const financialAccountRoot of financialAccountRoots) {
    if (!financialAccountRoot.finAcctId) {
      continue;
    }
    const users = await OrgsService.getFinancialAcctUsers(
      financialAccountRoot.finAcctId,
    );
    const matchingUser = users.find((u) => u.kycId === kycId);
    if (matchingUser) {
      kycIsInherited = true;
      break;
    }
  }
  return kycIsInherited;
};
